module.exports = __webpack_public_path__ + "img/placeholder.a6caa894.png";